import { SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';

export const syncSocialChannelsV1RequestSchema = z.object({
  provider: z.enum(SOCIAL_PROVIDERS),
});

export type ISyncSocialChannelsV1Request = z.infer<typeof syncSocialChannelsV1RequestSchema>;
